import { factKey, type StudentProgress } from "../engine/progress";

/** Rows 1–12 by columns 0–12; cell class s0–s3 (not tried, revisit, correct, fluent). */
export function factMapHTML(p: StudentProgress, op: "mul" | "div" = "mul"): string {
  let h = `<tr><th>${op === "div" ? "÷" : "×"}</th>`;
  const lo = op === "div" ? 1 : 0;
  for (let b = lo; b <= 12; b++) h += `<th>${b}</th>`;
  h += "</tr>";
  for (let a = 1; a <= 12; a++) {
    h += `<tr><th>${a}</th>`;
    for (let b = lo; b <= 12; b++) {
      const f = p.facts[factKey(a, b, op)];
      const s = f?.s ?? 0;
      h += `<td class="s${s}" title="${op === "div" ? `${a * b} ÷ ${a}` : `${a} × ${b}`}${f?.ms ? ` · best ${(f.ms / 1000).toFixed(1)} s` : ""}"></td>`;
    }
    h += "</tr>";
  }
  return h;
}

/** True once any division fact has been tried. */
export const hasDivision = (p: StudentProgress): boolean => Object.keys(p.facts).some((k) => k.includes("÷"));

export const LEGEND = `<div class="legend">
  <span><i></i>Not tried</span>
  <span><i style="background:var(--warn);border-color:var(--warn)"></i>Revisit</span>
  <span><i style="background:var(--sky);border-color:var(--navy)"></i>Correct</span>
  <span><i style="background:var(--navy);border-color:var(--navy)"></i>Fluent: no tools, under 3 sec</span>
</div>`;
